export default __webpack_public_path__ + "static/media/line-chart.d2a25d85.svg";